import { InjectionToken } from '@angular/core';
import { AuthConfig } from '../models/auth-config';

export const AUTH_CONFIG: InjectionToken<AuthConfig> = new InjectionToken<AuthConfig>(
  'AUTH_CONFIG'
);
